import { type DocStore } from 'stores/DocStore'
import { makeAutoObservable, observable, ObservableSet, values } from 'mobx'
import { Comment } from 'types'
import { CommentableType } from '../components/ActivityEvent/Types'

export class DecisionModeStore {
  docStore: DocStore
  private _decisionCommentIds: ObservableSet<number> = observable.set()
  private _snapshot: ObservableSet<number> = observable.set(this._decisionCommentIds)

  constructor(docStore: DocStore) {
    makeAutoObservable(this)
    this.docStore = docStore
  }

  get comments() {
    return this.docStore.comments
  }

  get commentIds() {
    return this.comments.map((comment) => comment.id)
  }

  get decisionableComments() {
    return this.docStore.rootStore.comments.all.filter(
      (comment) =>
        (comment.commentable_type === CommentableType.COMMENT &&
          this.commentIds.includes(comment.commentable_id as number)) ||
        this.commentIds.includes(comment.id),
    )
  }

  get decisionCommentIds() {
    return values(this._decisionCommentIds) as number[]
  }

  toggleCommentAsDecision = (comment: Comment) => {
    if (this.isCommentMarkedAsDecision(comment)) {
      this._decisionCommentIds.delete(comment.id)
      return this
    }
    this._decisionCommentIds.add(comment.id)
    return this
  }

  isCommentMarkedAsDecision = (comment: Comment): boolean => {
    return this._decisionCommentIds.has(comment.id)
  }

  snapshot = () => {
    this._snapshot = observable.set(this._decisionCommentIds)
  }

  revert = () => {
    this._decisionCommentIds = observable.set(this._snapshot)
  }

  clear = () => {
    this._decisionCommentIds.clear()
  }
}
